import type { ReactNode } from "react";

/**
 * Page title block for routes rendered directly on the dark shell (inside
 * AppShell, above the opaque cards).
 *
 * Why this exists: body text is the dark `foreground` color so card content
 * stays readable, which means anything sitting on the shell background must
 * explicitly opt into `text-shell-foreground` (see the body color comment in
 * client/src/index.css). New pages kept shipping bare `<h1>`s that rendered
 * dark-on-dark. Use this component for every shell-level title so the color
 * rule lives in exactly one place.
 */
export function PageHeader({
    title,
    description,
    icon,
    actions,
}: {
    title: ReactNode;
    description?: ReactNode;
    icon?: ReactNode;
    actions?: ReactNode;
}) {
    return (
        <div className="flex items-center justify-between gap-4">
            <div>
                <h1 className="text-2xl font-black tracking-tight text-shell-foreground flex items-center gap-2">
                    {icon}
                    {title}
                </h1>
                {description !== undefined && <p className="text-sm text-shell-foreground/80 mt-1">{description}</p>}
            </div>
            {actions}
        </div>
    );
}
